import historyAPI from '@/api/history.api.js';
/**
 * 答案质量反馈Mixin
 */
export default {
    methods: {

        /**
         * 答案质量反馈
         */
        async sendFeedBack (data, feedback) {
            if (!data.questionId || data.feedback === 1 || data.feedback === -1) return;
            data.feedback = feedback;
            let payload = {
                likeOrNot: feedback,
                questionId: data.questionId
            };
            let result;
            try {
                result = await historyAPI.sendFeedback(payload);
            } catch (error) {
                console.error(error);
                data.feedback = 0;
            }
        }
    }
};
